<template>
  <v-app overflow-x-hidden>
    <v-app-bar
      app
      color="black"
      dark
      dense
      elevated
      >
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>


      <v-container
        v-if="$vuetify.breakpoint.mdAndUp"
        >
        <v-btn v-for="(c, i) in contactInfo"
               :key=i
               text
               disabled
             >
          <font-awesome-icon color="blue" :icon="{prefix: 'fas', iconName: c.icon}"/><font color="white"> {{c.text}}</font>
          </v-btn>
      </v-container>

      <v-card
        v-else
        href="tel:908.419.5443"
        >
        <v-icon>mdi-phone</v-icon> 908.419.5443
      </v-card>

      <v-spacer/>

      <v-btn
        v-for="(x, i) in socials"
        :key=i
	@click="callLink(i)"
        icon large
        style = "min-width: 0"
        >
        <font-awesome-icon :icon="{prefix: 'fab', iconName: x.icon}"/>
      </v-btn>

      <v-btn @click="inOrOut">
        {{(auth) ? "Logout" : "Login"}}
      </v-btn>

      <template v-slot:extension v-if="$vuetify.breakpoint.mdAndUp">
         <v-img
              src="https://www.skyfarm.com/assets/skyfarm_logo_fixed.png"
              class="mt-1"
              contain
           height="50"/>
          <v-tabs align-with-title>
            <v-tab
              v-for="(opt, i) in options"
              :key=i
              :to=opt.route>
              {{opt.text}}</v-tab>
          </v-tabs>
        </template>

    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      >
      <v-list
        nav
        dense
        >
        <v-list-item-group
          >
          <v-list-item
            v-for="(opt, i) in options"
            :key=i
            :to=opt.route
            >
            <v-list-item-title>{{opt.text}}</v-list-item-title>
          </v-list-item>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-img
        v-if="$vuetify.breakpoint.smAndDown"
        src="https://www.skyfarm.com/assets/logo-2.png"
        class="mt-5"
        contain
        height="50"/>
      <v-divider/>
      <router-view/>
    </v-main>

    <v-footer dark>
      <v-container fluid>
        <v-row>
          Copyright (c) 2024 Sky Farm Inc. all rights reserved. Made with Vue. Build: {{build}}
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';
import router from './router.js';

export default {
    name: 'App',
    data: () => ({
        drawer: false,
        build: (process.env.VUE_APP_BUILD_NUMBER == null) ? "N/A" : process.env.VUE_APP_BUILD_NUMBER,
        overlay: false,
        options: [
            {text:'Home',             route:'/'},
            {text:'About Us',         route:'/about'},
//            {text:'Events',           route:'/events'},
            {text:'Membership',       route:'/membership'},
            {text:'Reviews',          route:'/reviews'},
            {text:'FAQ',              route:'/faq'},
            {text:'Member Access',    route:'/members'}
        ],
        contactInfo: [
            {text:'New Jersey',             icon:'map-marker'},
            {text:'908-419-5443',           icon:'phone'},
            {text:'membership@skyfarm.com', icon:'envelope'}
        ],
        socials: [
            {url: "https://www.facebook.com/skyfarmnj", icon: "facebook"},
            {url: "https://twitter.com/intent/follow?original_referer=http%3A%2F%2Fwww.skyfarm.com%2F&ref_src=twsrc%5Etfw&region=follow_link&screen_name=SkyFarmNJ&tw_p=followbutton", icon: "twitter"},
         { url: "https://www.instagram.com/skyfarmnj", icon: "instagram" },
        ]
    }),
    methods: {
        inOrOut() {
            if (this.auth) {
                this.$store.dispatch('logout')
                this.$gtag.event('logout')
            } else {
                //this.overlay = true
		this.$memberProfile['store'] = null;
                router.push('/members')
            }
        },
        callLink(i) {
            this.$gtag.event('linkto', { event_label: this.socials[i].icon });
            window.open(this.socials[i].url, '_blank')
        }
    },
    computed: {
        auth() {return this.$store.getters.ifAuthenticated}
    },
    created() {
        this.$store.dispatch('AutoLogin')
    }
};
</script>
